
import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, CreateDateColumn, UpdateDateColumn } from 'typeorm';

@Entity('recruitment-activities')
export class RecruitmentActivities{

    @PrimaryGeneratedColumn('increment', {name: 'recruitment_activity_id'})
    recruitmentActivityId: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'candidate_name'
    })
    candidateName: string;

    @Column('varchar', {
        nullable: false,
        length: 60,
        name: 'activity'
    })
    activity: string;

    @Column({
        nullable: false,
        name: 'activity_date'
    })
    activityDate: Date;

    @Column('varchar',{
        nullable: true,
        length: 60,
        name: 'remarks'
    })
    remarks: string;


    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;
    
    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}

